import { Helmet } from "react-helmet-async";
import DoctorsDirectory from "../00-Dashboard/DoctorsDirectory";
import TypesOfService from "../00-Dashboard/TypesOfService";
import FormOurServices from "../00-Dashboard/FormOurServices";
import FrequentlyQuestions from "../00-Dashboard/FrequentlyQuestions";
import CommitmentStats from "../00-Dashboard/CommitmentStats";
import HomeCareServices from "../00-Dashboard/HomeCareServices";
import InsuranceCompanies from "../components/InsuranceCompanies";
import LaboratoryServices from "../00-Dashboard/LaboratoryServices";
import WelcomeModal from "../components/WelcomeModal";

const Home = () => {
  return (
    <>
      <Helmet>
        <html lang="es-MX" />
        <title>
          Centro Médico MEDAM | Hospital, urgencias, laboratorio y especialistas
          en Texcoco
        </title>
        <meta
          name="description"
          content="Centro Médico MEDAM en Texcoco ofrece urgencias 24 horas, hospitalización, laboratorio clínico, especialistas, servicios a domicilio y atención con diversas aseguradoras."
        />
        <meta
          name="keywords"
          content="Centro Médico MEDAM, hospital en Texcoco, urgencias 24 horas, laboratorio clínico, médicos especialistas, hospitalización, servicios médicos, consulta médica Texcoco, aseguradoras, servicios a domicilio"
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Centro Médico MEDAM" />
        <link rel="canonical" href="https://centromedicomedam.com/" />

        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_MX" />
        <meta
          property="og:title"
          content="Centro Médico MEDAM | Hospital y especialistas en Texcoco"
        />
        <meta
          property="og:description"
          content="Hospital con urgencias 24 horas, medicos especialistas, laboratorio clínico, hospitalización y servicios médicos integrales en Texcoco."
        />
        <meta property="og:url" content="https://centromedicomedam.com/" />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        <meta property="og:site_name" content="Centro Médico MEDAM" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Centro Médico MEDAM | Hospital, urgencias y especialistas"
        />
        <meta
          name="twitter:description"
          content="Atención médica integral en Texcoco con urgencias 24 horas, especialistas, laboratorio y servicios a domicilio."
        />
        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "Centro Médico MEDAM",
              "url": "https://centromedicomedam.com",
              "potentialAction": {
                "@type": "SearchAction",
                "target": {
                  "@type": "EntryPoint",
                  "urlTemplate": "https://centromedicomedam.com/?q={search_term_string}"
                },
                "query-input": "required name=search_term_string"
              }
            }
          `}
        </script>

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Hospital",
              "name": "Centro Médico MEDAM",
              "url": "https://centromedicomedam.com",
              "logo": "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png",
              "image": "https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png",
              "telephone": "+525959570961",
              "email": "contacto@centromedicomedam.com",
              "priceRange": "$$",
              "openingHours": "Mo-Su 00:00-23:59",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Calpulalpan-Texcoco 105, Xala",
                "addressLocality": "Texcoco de Mora",
                "addressRegion": "Estado de México",
                "postalCode": "56270",
                "addressCountry": "MX"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 19.5225829,
                "longitude": -98.8770796
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "customer service",
                "telephone": "+525959570961",
                "availableLanguage": "Spanish"
              },
              "medicalSpecialty": [
                "Urgencias",
                "Laboratorio Clínico",
                "Medicina General",
                "Especialidades Médicas"
              ],
              "paymentAccepted": [
                "Cash",
                "Credit Card",
                "Debit Card"
              ],
              "areaServed": {
                "@type": "City",
                "name": "Texcoco"
              },
              "sameAs": [
                "https://www.facebook.com/share/19EGRopCww/?mibextid=wwXIfr",
                "https://www.instagram.com/centromedico_medam?igsh=ajhiYnFmenJjMXBo"
              ]
            }
          `}
        </script>

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Inicio",
                  "item": "https://centromedicomedam.com/"
                }
              ]
            }
          `}
        </script>
      </Helmet>
      <WelcomeModal />
      <DoctorsDirectory />
      <TypesOfService />
      <CommitmentStats />
      <InsuranceCompanies />
      <LaboratoryServices />
      <HomeCareServices />
      <FormOurServices />
      <FrequentlyQuestions />
    </>
  );
};
export default Home;
